export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Visibility-Gray-75759bbdf369253c4de6fe244d88b475.svg";